"use client"

import { type PropsWithChildren } from "react"
import clsx from "clsx"

import type { PropsWithClassName } from "~/@types/generics"
import { useAlgoliaSearch } from "~/hooks/useAlgoliaSearch"
import { GridLayout } from "~/components/ui/AlgoliaCollectionGrid/AlgoliaListingGrid/GridLayout/index.client"
import Pagination from "~/components/ui/Pagination"
import { useAlgoliaCustomContext } from "~/providers/AlgoliaCustomContext/index.client"

import { sprinkles } from "~/styles/sprinkles.css"

import * as css from "./styles.css"

export function AlgoliaGridContent({ className, children }: PropsWithClassName<PropsWithChildren>) {
  const { data } = useAlgoliaSearch()

  const { page } = useAlgoliaCustomContext()

  const currentPage = page || 1
  const totalPages = data?.nbPages || 1

  const hasPreviousPage = currentPage > 1
  const hasNextPage = currentPage < totalPages

  return (
    <div className={clsx(className, sprinkles({ position: "relative" }))}>
      <GridLayout>{children}</GridLayout>

      {Number(totalPages) && totalPages > 1 && (
        <Pagination
          className={css.pagination}
          hasPreviousPage={hasPreviousPage}
          hasNextPage={hasNextPage}
          // force number as passing a string might result in incoherent pagination
          currentPage={Number(currentPage)}
          maxPage={Number(totalPages)}
        />
      )}
    </div>
  )
}
